import React from "react";
import {
	styledSystem as ss,
	theme,
} from ".";

export type ILinkProps = ss.ICommonProps & ss.ILayoutProps & ss.IFontSizeProps
	& ss.ITypographyProps &
	{
		// Gatsby link props
		to?: string;
		activeClassName?: string
		activeStyle?: object;
		partiallyActive?: boolean;
		innerRef?: Function;
		replace?: boolean;
		getProps?: Function;

		// Common props
		hoverColor?: string;
		underline?: boolean;
		/**
		 * Set muted to true, to disable styling on hover
		 */
		muted?: boolean;
	}
;

const StyledLink = ss.styled.a``;

// Use a default GatsbyLink
let GatsbyLink: any = null;

// Try to load the link from Gatsby if installed and
// wrap it so that it does not pass props but it is still
// styled
try {
	const TheGatsbyLink = require("gatsby").Link;
	GatsbyLink = ss.styled(TheGatsbyLink)``;
}
catch (ex) {
}

/**
 * The default link
 */
export function BaseLink({underline, muted, hoverColor, ...props}: ILinkProps & Omit<JSX.IntrinsicElements["a"], "ref">) {
	if (props.to && GatsbyLink) {
		return <GatsbyLink {...props} />;
	}
	else {
		return <StyledLink {...props} />;
	}
}

export const Link = ss.styled(BaseLink)<ILinkProps>`
	color: ${ props => ss.get(props.theme, `colors.${props.color || "anchor"}`) };
	text-decoration: ${props => props.underline ? "underline" : "none" };
	&:hover {
		text-decoration: ${props => props.muted ? "none" : "underline" };
		color: ${ props => props.muted ? undefined : ss.get(props.theme, `colors.${props.hoverColor || "anchor"}`) };
	}
	${props => ((props as any).as === "button" ? {
		display: "inline-block",
		padding: "0",
		fontSize: "inherit",
		whiteSpace: "nowrap",
		cursor: "pointer",
		userSelect: "none",
		backgroundColor: "transparent",
		border: "0",
		appearance: "none",
	} : undefined)};
	${ss.COMMON}
	${ss.LAYOUT}
	${ss.FONTSIZE}
	${ss.TYPOGRAPHY}
`;
Link.defaultProps = {
	theme,
};